import { API_BASE,axiosApi } from "../config"
import {
    GeneralReturnInterface,
    GetAllUsersReturnInterface,
    GetUserDetailsReturnInterface,
    GetUserInSessionReturnInterface,
    LoginReturnInterface,
    UpdateUserReturnInterface,
    UserDetailsInterface,
} from "../types"

export const login = async (body: { email: string; password: string }): Promise<LoginReturnInterface> => {
    return (await axiosApi.post(`${API_BASE}/login`, body)).data
}

export const register = async (body: {
    email: string
    password: string
    firstName: string
    lastName: string
    institution: string
    captcha: string
}): Promise<LoginReturnInterface> => {
    return (await axiosApi.post(`${API_BASE}/register`, body)).data
}

export const getUserInSession = async (): Promise<GetUserInSessionReturnInterface> => {
    try {
        return (await axiosApi.post(`${API_BASE}/getUserInSession`)).data
        // return (await axios.post(`http://localhost:7281/api/getUserInSession`)).data
    } catch (error) {
        return { code: 900, user: { user: null, supervisor: null } }
    }
}

export const logout = async (): Promise<GeneralReturnInterface> => {
    return (await axiosApi.post(`${API_BASE}/logout`)).data
}

export const forgotPassword = async (body: { email: string; captcha: string }): Promise<GeneralReturnInterface> => {
    return (await axiosApi.post(`${API_BASE}/forgotpassword`, body)).data
}

export const resetPassword = async (body: {
    encrypt: string
    iv: string
    userId: number
    password: string
}): Promise<GeneralReturnInterface> => {
    return (await axiosApi.post(`${API_BASE}/resetpassword`, body)).data
}

export const changePassword = async (body: {
    password: string
    oldpassword: string
    email: string
}): Promise<GeneralReturnInterface> => {
    return (await axiosApi.post(`${API_BASE}/changepassword`, body)).data
}

export const getUsers = async (): Promise<GetAllUsersReturnInterface> => {
    const data = (await axiosApi.post(`${API_BASE}/getUsers`)).data
    return data
}

export const toggleActiveUser = async (body: { userId: number }): Promise<GeneralReturnInterface> => {
    return (await axiosApi.post(`${API_BASE}/toggleActiveUser`, body)).data
}

export const impersonate = async (body: { userId: number }): Promise<UpdateUserReturnInterface> => {
    return (await axiosApi.post(`${API_BASE}/impersonate`, body)).data
}

export const exitImpersonation = async (): Promise<UpdateUserReturnInterface> => {
    return (await axiosApi.post(`${API_BASE}/exitImpersonation`)).data
}

export const getUserName = async (body: { userId: number }): Promise<GeneralReturnInterface> => {
    return (await axiosApi.post(`${API_BASE}/getUserName`, body)).data
}

export async function getUserDetails(body: { userId: number }): Promise<GetUserDetailsReturnInterface> {
    return (await axiosApi.post(`${API_BASE}/getUserDetails`, body)).data
}

export async function getProfile(): Promise<GetUserDetailsReturnInterface> {
    return (await axiosApi.post(`${API_BASE}/getProfile`)).data
}

export async function updateUser(body: { user: UserDetailsInterface }): Promise<GeneralReturnInterface> {
    return (await axiosApi.post(`${API_BASE}/updateUser`, body)).data
}

export async function updateUserByAdmin(body: { 
    userId: number
    firstName?: string
    lastName?: string
    receive_group_order_notifications?: boolean
    view_group_orders?: boolean
    view_group_invoices?: boolean
}): Promise<GeneralReturnInterface> {
    return (await axiosApi.post(`${API_BASE}/updateUserByAdmin`, body)).data
}

export async function setUserPasswordByAdmin(body: { userId: number; password: string }): Promise<GeneralReturnInterface> {
    return (await axiosApi.post(`${API_BASE}/setUserPasswordByAdmin`, body)).data
}
